module.exports = __webpack_public_path__ + "static/media/FridgeEnviroDesigner.f986bb96.jpg";